<template>
    <el-dialog :visible.sync="visible"
               :title="!dataForm.id ? $t('add') : $t('update')"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="30%">
        <el-form :model="dataForm"
                 :rules="dataRule"
                 ref="dataForm"
                 label-position="top"
                 class="areamanager-add-form">
            <el-row class="row-mar-l-area">
                <el-col>
                    <el-form-item :label="$t('areaManager.name')"
                                  prop="userId">
                        <el-select v-model="dataForm.userId"
                                   clearable
                                   remote
                                   filterable
                                   reserve-keyword
                                   @change="changeChoice"
                                   :placeholder="$t('user.input')"
                                   :remote-method="queryUser">
                            <el-option v-for="item in userArr"
                                       :key="item.userId"
                                       :label="item.userInfo"
                                       :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="row-mar-l-area">
                <el-col>
                    <el-form-item :label="$t('areaManager.orgAbbreviation')"
                                  prop="orgId">
                        <el-select v-model="dataForm.orgId"
                                   remote
                                   clearable
                                   filterable
                                   reserve-keyword
                                   :disabled="canEdit"
                                   @change="changeChoice"
                                   :placeholder="$t('user.input')"
                                   :remote-method="querySearch">
                            <el-option v-for="item in results"
                                       :key="item.orgId"
                                       :label="item.name"
                                       :value="item.orgId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="row-mar-l-area">
                <el-col>
                    <el-form-item :label="$t('position.positionCode')"
                                  prop="jobCode">
                        <el-select v-model="dataForm.jobCode"
                                   clearable
                                   @change="changeChoice"
                                   :disabled="canEdit"
                                   :placeholder="$t('user.select')">
                            <el-option v-for="(item,index) in positionArr"
                                       :key="index"
                                       :label="item.jobCode + '-' +item.positionName"
                                       :value="item.jobCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col v-else>
                    <el-form-item :label="$t('areaManager.jobName')">
                        <el-input v-model="dataForm.jobName"
                                  :disabled="true"></el-input>
                    </el-form-item>
                </el-col> -->
            </el-row>
            <el-row>
                <el-col>
                    <el-button type="button"
                               class="buttonac el-button--primary"
                               @click="addUser()">{{ $t('save') }}</el-button>
                    <!-- @click="addUser()">{{ $t('save') }}</el-button> -->
                    <el-button plain
                               class="el-button-columnBtn"
                               @click="cancel()">{{ $t('cancel') }}</el-button>
                </el-col>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
    data() {
        return {
            visible: false,
            dataForm: {
                id: '',
                userId: '',
                orgId: '',
                jobCode: ''
            },
            userArr: [],
            results: [],
            positionArr: [],
            canEdit: ''
        }
    },

    computed: {
        dataRule() {
            return {
                // 用户
                userId: [
                    { required: true, message: this.$t('validate.required'), trigger: 'blur' },
                    // { validator: this.$validate.isSpecial, trigger: 'blur' },
                ],
                // 组织
                orgId: [
                    { required: true, message: this.$t('validate.required'), trigger: 'blur' }
                ],
                // 职位
                jobCode: [
                    { required: true, message: this.$t('validate.required'), trigger: 'blur' }
                ],
            }
        }
    },
    created() {
        //this.$refs['dataForm'].resetFields()
        // if (this.$refs.dataForm) {
        //     this.$refs['dataForm'].resetFields()
        // }
        this.$request.get('/sys/commAreaManager/areaPosition')
            .then((res, total, code, data) => {
                this.positionArr = res
                this.positionArr = JSON.parse(JSON.stringify(this.positionArr))
            }).catch((err) => {
                console.log(err)
            })

    },
    methods: {
        init() {
            this.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm.id === '') {
                    this.dataForm.userId = ''
                    this.dataForm.jobCode = ''
                    this.dataForm.orgId = ''
                }         
                if (this.dataForm.id) {
                    this.getInfo()
                }
            })
        },
        // initAdd(){
        //     this.visible = true
        //     this.$refs['dataForm'].resetFields();
        // },

        // 获取公司信息
        queryUser(queryString) {
            this.$request.get('/sys/commAreaManager/queryUser',
                {
                    name: queryString,
                }
            ).then((res, total, code, data) => {
                this.userArr = res
                this.userArr = this.userArr.map(item => {
                    item['value'] = item.userInfo
                    return item
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 获取公司信息
        querySearch(queryString) {
            this.$request.get('/sys/org/queryOutletList',
                {
                    name: queryString,
                }
            ).then((res, total, code, data) => {
                this.results = res
                this.results = this.results.map(item => {
                    item['value'] = item.name
                    return item
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        addUser() {
            this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                    return false
                }
                if (!this.dataForm.id || this.dataForm.id === '') {
                    this.$request.post(
                        '/sys/commAreaManager/save',
                        {
                            userId: this.dataForm.userId,
                            orgId: this.dataForm.orgId,
                            jobCode: this.dataForm.jobCode
                        }
                    ).then((res, tota, code, data) => {
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500
                        })
                        if (code === 1 && data.msg === 'success') {
                            this.visible = false
                            this.$emit('func', true)
                        }
                    }).catch((err) => {
                        console.log(err)
                    })

                } else {
                    let testId = this.dataForm.userId
                    if (testId.includes('_')) {
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500
                        })
                        this.visible = false
                        this.$emit('func', true)
                    } else {
                        this.$request.post(
                            '/sys/commAreaManager/update',
                            {
                                id: this.dataForm.id,
                                userId: this.dataForm.userId,
                            }
                        ).then((res, tota, code, data) => {
                            this.$message({
                                message: this.$t('prompt.success'),
                                type: 'success',
                                duration: 500
                            })
                            if (code === 1 && data.msg === 'success') {
                                this.visible = false
                                this.$emit('func', true)
                            }
                        }).catch((err) => {
                            console.log(err)
                        })
                    }
                }
            })


        },
        getInfo() {
            this.$request.get(`/sys/commAreaManager/info/${this.dataForm.id}`).then((res, total, code, data) => {
                this.dataForm = {
                    ...this.dataForm,
                    ...data.result
                }
            }).catch((err) => {
                console.log(err)
            })        },
        cancel() {
            this.visible = false
        },
        modifyUser() {
            this.canModify = false
        },
        changeChoice() {
            this.$forceUpdate()
        },
    },

}
</script>
 <style lang='scss' scope >
// .el-input-number {
//   width: 100% !important;
// }
// .el-input__inner {
//   text-align: left !important;
// }
// .buttonc {
//   margin: 0px !important;
//   width: 20%;
//   background-color: #434343;
//   color: #fff;
//   border: 0px;
//   line-height: 13px;
// }
// .buttonc:hover {
//   background: #535151 !important;
// }
.buttonac {
  margin-top: 10px;
  margin-left: 100px !important;
  // float: left !important;
  width: 20% !important;
  line-height: 14px;
  //padding-left:  50px;
}

.row-mar-l-area {
  padding-left: 60px;
}
</style>

